import { CustomCellRendererProps } from 'ag-grid-react';
import { absColDef, AdvancedColDef } from '../helpers/advancedHeader';
import { Purchase, Sell } from '@benzinga/valentyn-icons';
import styled from '@benzinga/themetron';

interface OwnProps {
  data: string;
}

type Props = OwnProps & CustomCellRendererProps;

const transactionRender: React.FC<Props> = params => {
  const value = params.value ?? '';
  return (
    <Div>
      {params.value === 'P' ? (
        <SpanPurchase>
          <Purchase />
          {value.includes('Partial') ? 'Purchase (Partial)' : 'Purchase'}
        </SpanPurchase>
      ) : (
        <SpanSell>
          <Sell />
          {value.includes('Partial') ? 'Sell (Partial)' : 'Sell'}
        </SpanSell>
      )}
    </Div>
  );
};

export const TransactionColDef = (colDef: AdvancedColDef): AdvancedColDef => ({
  cellRenderer: transactionRender,
  cellStyle: { 'text-align': 'left' },
  filter: 'agSetColumnFilter',
  initialPinned: true,
  ...colDef,
  ...absColDef(colDef),
});

const SpanPurchase = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--Other-Green, #30bfa3);
  line-height: 1;
  justify-content: start;
`;

const SpanSell = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--Other-Red, #cd4b5b);
  justify-content: start;
`;

const Div = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  font-family: 'Nimbus Sans D OT-Bold', Helvetica;
  font-size: 13px;
  font-weight: 600;
`;
